/* eslint-disable react/display-name */
import React from 'react';

export default props => (
  <svg
    {...props}
    width="552"
    height="527"
    viewBox="0 0 552 527"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M420 356C381.6 398.352 276 500 276 500C276 500 170.4 398.352 132 356C42.4 257.178 20 218.589 20 148C20 77.4118 71.2 20 148 20C212 20 250.4 62.353 276 104.706C301.6 62.353 340 20 404 20C480.8 20 532 77.4118 532 148C532 218.589 509.6 257.178 420 356Z"
      fill="currentColor"
      stroke="#4f2d1d"
      strokeWidth="38.4"
    />
  </svg>
);
